import "../styles/admin.css";

import { onAuthStateChanged, signOut, User } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "./firebase-config";
import { registerRoutes, startRouter, navigate, refreshRoute } from "./router";
import { renderAdminLogin, mountAdminLogin } from "./pages/login";
import { renderUsersPage, mountUsersPage } from "./pages/users";
import { renderFeedbackPage, mountFeedbackPage } from "./pages/feedback";

let isAdmin = false;

registerRoutes([
  {
    path: "/login",
    render: renderAdminLogin,
    onMount: mountAdminLogin,
  },
  {
    path: "/users",
    render: () => {
      if (!isAdmin) return renderAdminLogin();
      return renderUsersPage();
    },
    onMount: () => {
      if (!isAdmin) {
        mountAdminLogin();
        return;
      }
      mountUsersPage();
    },
  },
  {
    path: "/feedback",
    render: () => {
      if (!isAdmin) return renderAdminLogin();
      return renderFeedbackPage();
    },
    onMount: () => {
      if (!isAdmin) {
        mountAdminLogin();
        return;
      }
      mountFeedbackPage();
    },
  },
]);

// Auth state listener
onAuthStateChanged(auth, async (user: User | null) => {
  if (user) {
    const userDoc = await getDoc(doc(db, "users", user.uid));
    isAdmin = userDoc.exists() && userDoc.data()?.isAdmin === true;
  } else {
    isAdmin = false;
  }

  updateAdminNav(isAdmin);
  refreshRoute();
});

function updateAdminNav(loggedIn: boolean): void {
  const usersLink = document.getElementById("admin-nav-users");
  const feedbackLink = document.getElementById("admin-nav-feedback");
  const logoutBtn = document.getElementById("admin-nav-logout");

  if (usersLink) usersLink.style.display = loggedIn ? "" : "none";
  if (feedbackLink) feedbackLink.style.display = loggedIn ? "" : "none";
  if (logoutBtn) logoutBtn.style.display = loggedIn ? "" : "none";
}

// Logout
document.getElementById("admin-nav-logout")?.addEventListener("click", async () => {
  await signOut(auth);
  isAdmin = false;
  navigate("#/login");
});

startRouter();
